// noinspection JSUnresolvedReference

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  appointments({ detail: { content } }) {
    const uniqueSet = new Set(content.appointment_type_ids);
    const uniqueRequestCourseIds = new Set(content.course_ids);
    const uniqueRequestIds = new Set(content.request_ids);
    const payload = `${content.ids}&redirect=/appointment_requests&appointment_type_id=${[...uniqueSet][0]}&course_id=${[...uniqueRequestCourseIds][0]}&appointment_request_ids=${[...uniqueRequestIds]}`
    const headers = { "Content-Type": "application/x-www-form-urlencoded" }

    if (uniqueSet.size > 1) {
      alert("Multiple appointment types have been selected. Bulk schedule should be for the same type of appointment.");
    } else {
        this.doFetch("/appointments/new_in_bulk", headers, payload)
    }
  }

  appointmentsForCampaign({ detail: { content } }) {
    const appointmentTypeId = content.appointment_type_ids[0];
    const appointmentCampaignId = content.appointment_campaign_ids[0]
    const redirect = `/appointment_campaigns/${appointmentCampaignId}`
    const payload = `${[...content.ids]}&redirect=${redirect}&appointment_type_id=${appointmentTypeId}&campaign_recipient_slugs=${[...content.slugs]}`;
    const headers = { "Content-Type": "application/x-www-form-urlencoded" }

    this.doFetch("/appointments/new_in_bulk", headers, payload)
  }

  appointmentCampaigns({ detail: { content } }) {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
    }
    this.doFetch("/appointment_campaigns/new_in_bulk", headers, content.ids)
  }

  doFetch(path, headers, payload) {
    fetch(path, {
        method: "POST",
        headers: headers,
        body: `student_ids=${payload}`
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.url;
    })
    .then((responseUrl) => {
      window.location.href = responseUrl;
    })
    .catch(error => {
        console.error('Error:', error);
    });
  }
}
